module.exports = __webpack_public_path__ + "static/media/2.eb7fbe88.png";